import React from 'react';
import { addDays, relativeDay, fmtDay, diffDays, sortTasks, dayLoad, fmtDuration } from '../myDayUtils';
import TaskRow from './TaskRow';

const HORIZON = 7;

/** The week ahead, so a heavy Thursday is visible on Monday. */
export default function UpcomingView({ tasks, cats, today, settings, onToggle, onOpen, onAction, onPick }) {
  const open = tasks.filter(t => !t.archived);
  const horizon = Array.from({ length: HORIZON }, (_, i) => addDays(today, i));
  const later = sortTasks(open.filter(t => !t.done && diffDays(t.date, today) >= HORIZON));

  return (
    <div className="md-upcoming">
      <p className="md-lead">
        Seven days out. The load bar shows how much you've already committed against your
        {' '}{fmtDuration(settings.capacityMin)} daily capacity — an amber or red bar means
        something has to move.
      </p>

      {horizon.map(date => {
        const items = sortTasks(open.filter(t => t.date === date));
        const load = dayLoad(items, settings.capacityMin);
        return (
          <section key={date} className="md-card md-upcoming__day">
            <header className="md-card__head">
              <div>
                <h3 className="md-card__title">
                  {relativeDay(date, today)}
                  <span className="md-card__sub-inline">{fmtDay(date)}</span>
                </h3>
                <p className="md-card__sub">
                  {items.filter(t => !t.done).length} open · {items.filter(t => t.done).length} done
                  {load.plannedMin > 0 && ` · ${fmtDuration(load.plannedMin)} planned`}
                </p>
              </div>
              <button className="md-btn md-btn--sm" onClick={() => onPick(date)}>Open this day</button>
            </header>

            {load.plannedMin > 0 && (
              <div className={`md-load md-load--${load.state}`} title={`${fmtDuration(load.plannedMin)} planned of ${fmtDuration(load.capacityMin)}`}>
                <span className="md-load__fill" style={{ width: `${Math.min(100, load.pct)}%` }} />
                <span className="md-load__txt">{load.pct}% of capacity{load.state === 'over' ? ' — over-committed' : ''}</span>
              </div>
            )}

            {items.length === 0 ? (
              <p className="md-empty md-empty--sm">Nothing planned.</p>
            ) : (
              <ul className="md-list">
                {items.map(t => (
                  <TaskRow key={t.id} task={t} cats={cats} today={today}
                    onToggle={onToggle} onOpen={onOpen} onAction={onAction} />
                ))}
              </ul>
            )}
          </section>
        );
      })}

      {later.length > 0 && (
        <section className="md-card">
          <h3 className="md-card__title">Further out — {later.length}</h3>
          <ul className="md-list">
            {later.map(t => (
              <TaskRow key={t.id} task={t} cats={cats} today={today} showDate
                onToggle={onToggle} onOpen={onOpen} onAction={onAction} />
            ))}
          </ul>
        </section>
      )}
    </div>
  );
}
